"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _cloudimageResponsiveUtils = require("cloudimage-responsive-utils");

var _constants = require("cloudimage-responsive-utils/dist/constants");

var _utils = require("./utils.js");

var _img = _interopRequireDefault(require("./img.styles"));

var _reactLazyload = _interopRequireDefault(require("react-lazyload"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Img = /*#__PURE__*/function (_Component) {
  _inherits(Img, _Component);

  var _super = _createSuper(Img);

  function Img(props) {
    var _this;

    _classCallCheck(this, Img);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "processImg", function (update, windowScreenBecomesBigger) {
      var imgNode = (0, _reactDom.findDOMNode)(_assertThisInitialized(_this));
      var data = (0, _cloudimageResponsiveUtils.processReactNode)(_this.props, imgNode, update, windowScreenBecomesBigger);

      _this.setState(data);
    });

    _defineProperty(_assertThisInitialized(_this), "onPreviewLoaded", function (event) {
      if (_this.state.previewLoaded) return;

      _this.updateLoadedImageSize(event.target);

      _this.setState({
        previewLoaded: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateLoadedImageSize", function (image) {
      _this.setState({
        loadedImageWidth: image.naturalWidth,
        loadedImageHeight: image.naturalHeight,
        loadedImageRatio: image.naturalWidth / image.naturalHeight
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onImgLoad", function (event) {
      _this.updateLoadedImageSize(event.target);

      _this.setState({
        loaded: true
      });
    });

    _this.server = (0, _cloudimageResponsiveUtils.isServer)();
    _this.state = {
      cloudimgURL: '',
      loaded: false,
      processed: false
    };
    return _this;
  }

  _createClass(Img, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.server) return;
      var delay = this.props.config.delay;

      if (typeof delay !== 'undefined') {
        setTimeout(function () {
          _this2.processImg();
        }, delay);
      } else {
        this.processImg();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.server) return;
      var _this$props = this.props,
          innerWidth = _this$props.config.innerWidth,
          src = _this$props.src;

      if (prevProps.config.innerWidth !== innerWidth) {
        this.processImg(true, innerWidth > prevProps.config.innerWidth);
      }

      if (src !== prevProps.src) {
        this.processImg();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$config = this.props.config,
          config = _this$props$config === void 0 ? {} : _this$props$config;
      var placeholderBackground = config.placeholderBackground,
          configLazyLoadingValue = config.lazyLoading;
      var _this$props$lazyLoadi = this.props.lazyLoading,
          lazyLoading = _this$props$lazyLoadi === void 0 ? configLazyLoadingValue : _this$props$lazyLoadi;
      var _this$state = this.state,
          height = _this$state.height,
          ratio = _this$state.ratio,
          cloudimgURL = _this$state.cloudimgURL,
          cloudimgSRCSET = _this$state.cloudimgSRCSET,
          previewCloudimgURL = _this$state.previewCloudimgURL,
          loaded = _this$state.loaded,
          processed = _this$state.processed,
          previewLoaded = _this$state.previewLoaded,
          preview = _this$state.preview,
          loadedImageRatio = _this$state.loadedImageRatio,
          operation = _this$state.operation;
      if (this.server) return /*#__PURE__*/_react["default"].createElement("img", {
        alt: this.props.alt,
        src: _constants.BASE_64_PLACEHOLDER
      });
      if (!processed) return /*#__PURE__*/_react["default"].createElement("div", null);

      var _getFilteredProps = (0, _utils.getFilteredProps)(this.props),
          alt = _getFilteredProps.alt,
          className = _getFilteredProps.className,
          lazyLoadConfig = _getFilteredProps.lazyLoadConfig,
          preserveSize = _getFilteredProps.preserveSize,
          imgNodeWidth = _getFilteredProps.imgNodeWidth,
          imgNodeHeight = _getFilteredProps.imgNodeHeight,
          otherProps = _objectWithoutProperties(_getFilteredProps, ["alt", "className", "lazyLoadConfig", "preserveSize", "imgNodeWidth", "imgNodeHeight"]);

      var picture = /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(className, " cloudimage-image ").concat(loaded ? 'loaded' : 'loading').trim(),
        style: _img["default"].picture({
          preserveSize: preserveSize,
          imgNodeWidth: imgNodeWidth,
          imgNodeHeight: imgNodeHeight,
          ratio: ratio || loadedImageRatio,
          previewLoaded: previewLoaded,
          loaded: loaded,
          placeholderBackground: placeholderBackground,
          operation: operation
        })
      }, preview && operation !== 'bound' && /*#__PURE__*/_react["default"].createElement("div", {
        style: _img["default"].previewWrapper()
      }, /*#__PURE__*/_react["default"].createElement("img", {
        style: _img["default"].previewImg({
          loaded: loaded,
          operation: operation
        }),
        src: previewCloudimgURL,
        alt: "low quality preview image",
        onLoad: this.onPreviewLoaded
      })), /*#__PURE__*/_react["default"].createElement("img", _extends({
        alt: alt,
        style: _img["default"].img({
          preview: preview,
          loaded: loaded,
          operation: operation
        })
      }, otherProps, {
        src: cloudimgURL,
        onLoad: this.onImgLoad
      }, cloudimgSRCSET && {
        srcSet: cloudimgSRCSET.map(function (_ref) {
          var dpr = _ref.dpr,
              url = _ref.url;
          return "".concat(url, " ").concat(dpr, "x");
        }).join(', ')
      })));

      return lazyLoading ? /*#__PURE__*/_react["default"].createElement(_reactLazyload["default"], _extends({
        height: height,
        offset: config.lazyLoadOffset
      }, lazyLoadConfig), picture) : picture;
    }
  }]);

  return Img;
}(_react.Component);

var _default = Img;
exports["default"] = _default;